<template>
  <!-- View Details -->
  <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade details-modal"
       role="dialog"
       tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-full modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header d-flex align-items-center">
          <div class="d-flex justify-content-between flex-grow-1 align-items-center">
            <div class="d-flex align-items-center">
              <h5 class="modal-title" id="myLargeModalLabel">{{businessDetails.businessName}} Business Details ##</h5>
              <span class="badge rounded-pill bg-success text-uppercase font-12px text-uppercase mx-3">Invoiced for {{invoicingYear}}</span>
            </div>
            <div>
              <a type="button" target="blank" @click="onPrintBill(billDetailNew.billNo)" href="javascript: void(0);" class="btn btn-info waves-effect btn-label waves-light text-uppercase mx-3"><i class="dripicons-print label-icon "></i> Print {{invoicingYear}} Invoice</a>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">

            <!-- COLUMN 1: Business Details -->
            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-info border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bx-briefcase-alt-2 font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">Business Details </p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">Business Details</th>
                      </thead>
                      <tbody>
                      <tr>
                        <td><strong>Business Name</strong></td>
                        <td>{{businessDetails.businessName}}</td>
                      </tr>
                      <tr>
                        <td><strong>Business ID</strong></td>
                        <td>{{businessDetails.businessID}}</td>
                      </tr>
                      <tr>
                        <td><strong>Sub County</strong></td>
                        <td>{{businessDetails.subCountyName}}</td>
                      </tr>
                      <tr>
                        <td><strong>Ward</strong></td>
                        <td>{{businessDetails.wardName}}</td>
                      </tr>
                      <tr>
                        <td><strong>Zone</strong></td>
                        <td>{{businessDetails.zone}}</td>
                      </tr>
                      <tr>
                        <td><strong>Plot No.</strong></td>
                        <td>{{businessDetails.plotNumber}}</td>
                      </tr>
                      <tr>
                        <td><strong>VAT No.</strong></td>
                        <td>{{businessDetails.kraPin}}</td>
                      </tr>
                      <tr>
                        <td><strong>Physical Address</strong></td>
                        <td>{{businessDetails.physicalAddress}}</td>
                      </tr>
                      <tr>
                        <td><strong>Building Name</strong></td>
                        <td>{{businessDetails.buildingName}}</td>
                      </tr>
                      <tr>
                        <td><strong>Floor Number</strong></td>
                        <td>{{businessDetails.floorNo}}</td>
                      </tr>
                      <tr>
                        <td><strong>Stall/Room No.</strong></td>
                        <td>{{businessDetails.roomNo}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Previous Year Invoice Details -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-warning">
                      <th colspan="3" class="text-uppercase">
                        <div class="justify-content-between d-flex">
                          <div>{{entry.year}} Invoice Details</div>
                          <div>
                            <a @click="onPrintBill(entry.billNo)" href="javascript: void(0);" target="new" class="btn btn-primary btn-sm text-uppercase">Open</a>
                          </div>
                        </div>
                      </th>
                      </thead>
                      <tbody>
                      <tr class="fw-semibold text-uppercase">
                        <td class="text-primary"><strong>Invoice No.</strong></td>
                        <td><span class="text-primary">{{billDetail.billNo}}</span></td>
                      </tr>
                      <tr class="fw-semibold text-uppercase">
                        <td class="text-primary"><strong>Total Invoiced</strong></td>
                        <td><span class="text-primary">KES {{numberFormat(billDetail.detailAmount)}}</span></td>
                      </tr>
                      <tr class="fw-semibold text-uppercase">
                        <td class="text-primary"><strong>Amount Paid</strong></td>
                        <td><span class="text-primary">KES {{numberFormat(billDetail.receiptAmount)}}</span></td>
                      </tr>
                      <tr class="fw-semibold text-uppercase">
                        <td class="text-primary"><strong>Balance</strong></td>
                        <td><span class="text-primary">KES {{numberFormat(billDetail.billBalance)}}</span></td>
                      </tr>
                      <tr class="fw-semibold text-uppercase">
                        <td class="text-primary"><strong>Invoiced By</strong></td>
                        <td><span class="text-primary">{{billDetail.names}}</span></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- COLUMN 2: Ownership & Contact Information -->
            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-warning border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bxs-user-pin font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">Ownership and Business's Contact information</p>
                  </div>
                </div>

                <!-- Owner Details -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">Owner Details</th>
                      </thead>
                      <tbody>
                      <tr>
                        <td><strong>Full Names</strong></td>
                        <td>{{businessDetails.fullNames}}</td>
                      </tr>
                      <tr>
                        <td><strong>Owner's ID</strong></td>
                        <td>{{businessDetails.ownerID}}</td>
                      </tr>
                      <tr>
                        <td><strong>Owner's Phone No.</strong></td>
                        <td>{{businessDetails.ownerPhone}}</td>
                      </tr>
                      <tr>
                        <td><strong>Email Address</strong></td>
                        <td>{{businessDetails.ownerEmail}}</td>
                      </tr>
                      <tr>
                        <td><strong>KRA PIN No.</strong></td>
                        <td>{{businessDetails.kraPin}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Business Contact Information -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">Business Contact Information</th>
                      </thead>
                      <tbody>
                      <tr>
                        <td><strong>Business Phone No.</strong></td>
                        <td>{{businessDetails.businessPhone}}</td>
                      </tr>
                      <tr>
                        <td><strong>Business Email</strong></td>
                        <td>{{businessDetails.businessEmail || businessDetails.ownerEmail}}</td>
                      </tr>
                      <tr>
                        <td><strong>Postal Address</strong></td>
                        <td>{{businessDetails.postalAddress}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Contact Person -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">Contact Person</th>
                      </thead>
                      <tbody>
                      <tr>
                        <td><strong>Full Names</strong></td>
                        <td>{{businessDetails.contactPersonNames || businessDetails.fullNames}}</td>
                      </tr>
                      <tr>
                        <td><strong>ID Number</strong></td>
                        <td>{{businessDetails.contactPersonIDNo || businessDetails.ownerID}}</td>
                      </tr>
                      <tr>
                        <td><strong>Role</strong></td>
                        <td>{{businessDetails.businessRole}}</td>
                      </tr>
                      <tr>
                        <td><strong>Phone Number</strong></td>
                        <td>{{businessDetails.contactPersonPhone || businessDetails.ownerPhone}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- COLUMN 3: Billing and Business Categorization -->
            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center rounded">
                    <i class="bx bxs-wallet font-28 mr-15px"></i>
                    <p class="fw-bold mb-0">Billing and Business Categorization Details</p>
                  </div>
                </div>

                <!-- SBP Categorization -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <th colspan="3" class="text-uppercase">SBP Categorization Fees</th>
                      </thead>
                      <tbody>
                      <tr>
                        <td><strong>Category</strong></td>
                        <td>{{businessDetails.businessCategory}}</td>
                      </tr>
                      <tr>
                        <td><strong>Sub category</strong></td>
                        <td>{{businessDetails.businessSubCategory}}</td>
                      </tr>
                      <tr>
                        <td><strong>Business Activity</strong></td>
                        <td>{{businessDetails.businessDes}}</td>
                      </tr>
                      <tr>
                        <td><strong>SBP Charges</strong></td>
                        <td><span class="text-primary fs-5 fw-bold">KES {{numberFormat(getNewSbpAmount())}}</span></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Previous Year Charges -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-bordered table-sm">
                      <thead class="table-warning">
                      <tr>
                        <th class="text-uppercase" colspan="3">{{entry.year}} Charges (Previous)</th>
                      </tr>
                      <tr class="text-uppercase">
                        <th>#</th>
                        <th>Item</th>
                        <th class="text-right">Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in billInfo" :key="'prev-'+index" :class="{'text-muted': isItemMissing(item.feeDescription)}">
                        <td>{{index+1}}</td>
                        <td>
                          <strike v-if="isItemMissing(item.feeDescription)">{{item.feeDescription}}</strike>
                          <span v-else>{{item.feeDescription}}</span>
                        </td>
                        <td class="text-right">KES {{numberFormat(item.billTotal)}}</td>
                      </tr>
                      </tbody>
                      <tfoot class="table-warning">
                      <tr>
                        <th colspan="2" class="text-uppercase">Total</th>
                        <th class="text-right">KES {{numberFormat(billDetail.detailAmount)}}</th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- New Year Charges -->
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-bordered table-sm">
                      <thead class="table-success">
                      <tr>
                        <th class="text-uppercase" colspan="3">{{invoicingYear}} Charges (Current)</th>
                      </tr>
                      <tr class="text-uppercase">
                        <th>#</th>
                        <th>Item</th>
                        <th class="text-right">Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in billInfoNew" :key="'new-'+index" :class="{'text-success fw-bold': isNewItem(item.feeDescription)}">
                        <td>{{index+1}}</td>
                        <td>
                          {{item.feeDescription}}
                          <span v-if="isNewItem(item.feeDescription)" class="badge bg-success ms-2">NEW</span>
                        </td>
                        <td class="text-right">KES {{numberFormat(item.billTotal)}}</td>
                      </tr>
                      </tbody>
                      <tfoot class="table-success">
                      <tr>
                        <th colspan="2" class="text-uppercase">Total</th>
                        <th class="text-right">KES {{numberFormat(billDetailNew.detailAmount)}}</th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- Fee Change Notification -->
                <!-- Downgrade -->
                <div v-if="Number(entry.billTotal) > Number(getNewSbpAmount())" class="col-12">
                  <div class="card bg-danger text-white-50 mb-2">
                    <div class="card-body py-2">
                      <h6 class="mb-2 text-white text-uppercase"><i class="mdi mdi-arrow-down-bold me-2"></i>Fee Reduced</h6>
                      <p class="card-text mb-0 small">Reduced by KES {{numberFormat(Number(entry.billTotal)-Number(getNewSbpAmount()))}}</p>
                    </div>
                  </div>
                </div>

                <!-- Maintained -->
                <div v-if="Number(entry.billTotal) === Number(getNewSbpAmount())" class="col-12">
                  <div class="card bg-primary text-white-50 mb-2">
                    <div class="card-body py-2">
                      <h6 class="mb-2 text-white text-uppercase"><i class="mdi mdi-equal me-2"></i>Fee Maintained</h6>
                      <p class="card-text mb-0 small">Same amount as previous year</p>
                    </div>
                  </div>
                </div>

                <!-- Upgraded -->
                <div v-if="Number(entry.billTotal) < Number(getNewSbpAmount())" class="col-12">
                  <div class="card bg-success text-white-50 mb-2">
                    <div class="card-body py-2">
                      <h6 class="mb-2 text-white text-uppercase"><i class="mdi mdi-arrow-up-bold me-2"></i>Business Upgraded</h6>
                      <p class="card-text mb-0 small">Increased by KES {{numberFormat(Number(getNewSbpAmount())-Number(entry.billTotal))}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- COLUMN 4: Map View -->
            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-dark border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bx-map font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">Map View</p>
                  </div>
                </div>
                <div class="col-12">
                  <iframe
                      :src="mapUrl"
                      width="100%"
                      height="350"
                      style="border:0;"
                      allowfullscreen
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade">
                  </iframe>
                </div>
              </div>
            </div>

            <!-- COLUMN 5: Changes Done -->
            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-warning border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bxs-check-circle font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">Changes and Updates Done</p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                      <thead class="table-light">
                      <tr>
                        <th class="text-uppercase">Field</th>
                        <th class="text-uppercase">Changes</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="changesDone.length === 0">
                        <td colspan="2" class="text-center text-muted">No changes recorded</td>
                      </tr>
                      <tr v-for="(item, index) in changesDone" :key="'change-'+index">
                        <td><strong>{{formatFieldName(item.key)}}</strong></td>
                        <td>
                          <p class="mb-0 text-danger"><small><strong>From:</strong> {{item.originalName || 'N/A'}}</small></p>
                          <p class="mb-0 text-success"><small><strong>To:</strong> {{item.newName || 'N/A'}}</small></p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Remarks -->
                <div v-if="entry.remarks" class="col-12">
                  <div class="alert alert-info border-1 border-info">
                    <p class="fw-bold text-uppercase mb-1">Remarks from Licensing Officer</p>
                    <p class="mb-0 text-black">{{entry.remarks}}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- COLUMN 6: Licensing Summary -->
            <div class="col-sm-12 col-md-4">
              <div class="row">
                <div class="col-12 mt-4">
                  <div class="bg-success border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                    <i class="bx bxs-badge-check font-28 mr-15px"></i>
                    <p class="fw-semibold mb-0 pb-0">{{invoicingYear}} Licensing Summary</p>
                  </div>
                </div>

                <div class="col-12">
                  <!-- Previous Year Summary -->
                  <div class="alert alert-warning border-1 border-warning mb-3">
                    <h6 class="text-uppercase fw-bold mb-2">{{entry.year}} Invoice Summary</h6>
                    <ul class="mb-0 small">
                      <li><strong>Invoice No:</strong> {{entry.billNo}}</li>
                      <li><strong>Amount:</strong> KES {{numberFormat(entry.billTotal)}}</li>
                      <li><strong>Subcategory:</strong> {{entry.feeDescription}}</li>
                      <li><strong>Items:</strong> {{billInfo.length}}</li>
                    </ul>
                    <a @click="onPrintBill(entry.billNo)" href="javascript: void(0);" class="btn btn-sm btn-outline-primary mt-2">
                      <i class="bx bx-printer me-1"></i> View Invoice
                    </a>
                  </div>

                  <!-- New Year Summary -->
                  <div class="alert alert-success border-1 border-success mb-3">
                    <h6 class="text-uppercase fw-bold mb-2">{{invoicingYear}} Invoice Summary</h6>
                    <ul class="mb-0 small">
                      <li><strong>Invoice No:</strong> {{billDetailNew.billNo}}</li>
                      <li><strong>Amount:</strong> KES {{numberFormat(billDetailNew.detailAmount)}}</li>
                      <li><strong>Subcategory:</strong> {{getNewSubCategory()}}</li>
                      <li><strong>Items:</strong> {{billInfoNew.length}}</li>
                    </ul>
                    <a @click="onPrintBill(billDetailNew.billNo)" href="javascript: void(0);" class="btn btn-sm btn-outline-success mt-2">
                      <i class="bx bx-printer me-1"></i> View Invoice
                    </a>
                  </div>

                  <!-- Processing Info -->
                  <div class="alert alert-light border mb-0">
                    <h6 class="text-uppercase fw-bold mb-2">Processing Information</h6>
                    <ul class="mb-0 small">
                      <li><strong>Processed By:</strong> {{billDetailNew.names}}</li>
                      <li><strong>Processed On:</strong> {{formattedDate(billDetailNew.dateCreated)}}</li>
                      <li><strong>Status:</strong> <span class="badge bg-success">INVOICED</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <a @click="onPrintBill(billDetailNew.billNo)" href="javascript: void(0);" class="btn btn-primary">
            <i class="mdi mdi-printer me-2"></i> Print {{invoicingYear}} Invoice
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'

export default {
  name: "DetailsModal",
  props: {
    businessDetails: {
      type: Object,
      required: true
    },
    entry: {
      type: Object,
      required: true
    },
    billDetail: {
      type: Object,
      required: true
    },
    billDetailNew: {
      type: Object,
      default: () => ({})
    },
    billInfo: {
      type: Array,
      default: () => []
    },
    billInfoNew: {
      type: Array,
      default: () => []
    },
    changesDone: {
      type: Array,
      default: () => []
    },
    selectedFiscalYear: {
      type: Number,
      default: null
    }
  },
  computed: {
    invoicingYear() {
      // Use the selected fiscal year if available, otherwise fall back to entry.year + 1
      return this.selectedFiscalYear || Number(this.entry.year) + 1;
    },
    mapUrl() {
      const encodedBusinessName = encodeURIComponent(this.businessDetails.businessName || '');
      return `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d46449.71551863634!2d${this.businessDetails.lng || 0}!3d${this.businessDetails.lat || 0}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f0cb9ff59a4a3%3A0x4073419e11826405!2s${encodedBusinessName}!5e0!3m2!1sen!2ske!4v1691859398886!5m2!1sen!2ske`;
    }
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },
    formattedDate(date) {
      if (!date) return 'N/A';
      return moment(date).format('DD MMM YYYY hh:mm A') + ' (' + moment(date).fromNow() + ')';
    },
    getNewSbpAmount() {
      const matchingBill = this.billInfoNew.find(bill => bill.customer?.includes("Business ID"));
      return matchingBill ? matchingBill.billTotal : 0;
    },
    getNewSubCategory() {
      const matchingBill = this.billInfoNew.find(bill => bill.customer?.includes("Business ID"));
      return matchingBill ? matchingBill.feeDescription : this.businessDetails.businessSubCategory;
    },
    isItemMissing(feeDescription) {
      return !this.billInfoNew.some(info => info.feeDescription === feeDescription);
    },
    isNewItem(feeDescription) {
      return !this.billInfo.some(info => info.feeDescription === feeDescription);
    },
    formatFieldName(key) {
      // Convert camelCase to Title Case with spaces
      return key
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase())
          .trim();
    },
    onPrintBill(billNo) {
      this.$emit('printBill', billNo);
    },
    onPrintReceipt() {
      this.$emit('printReceipt');
    }
  }
}
</script>

<style scoped>
</style>